import { Router, RouterModule } from '@angular/router';
import { htmlUrls } from '@shared/utils/router-paths';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ChangeDetectionStrategy, Component, Injector, Input, OnInit, inject } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { LocalRepository } from '@shared/helper/local-repository';
import { MatButtonModule } from '@angular/material/button';
import { SharedModule } from '@shared/module/shared.module';


@Component({
    selector: 'app-floating-actions',
    templateUrl: './floating-actions.component.html',
    styleUrls: ['./floating-actions.component.scss'],
    imports: [
        SharedModule,
        RouterModule,
        MatButtonModule,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FloatingActionsComponent extends BaseComponent implements OnInit {
  private router = inject(Router);
  private injector = inject(Injector);
  private _localRepository = inject(LocalRepository);

  @Input() displayActions!: boolean;
  @Input() displayAdd = false;

  routes = htmlUrls;


  private dialogData;
  private dialogRef: any = null;

  constructor() {
    super();
    // this.currentUser.checkUserRole();
    this.dialogRef = this.injector.get(MatDialogRef, FloatingActionsComponent);
    this.dialogData = this.injector.get(MAT_DIALOG_DATA, FloatingActionsComponent);
  }

  ngOnInit(): void {
    this.dialogData?.displayActions != undefined ? this.displayActions = this.dialogData?.displayActions : null;
  }

  closeDialog(link?: string) {
    if (this._localRepository.IsInMobile) {
      this.dialogRef?.close({ type: null });
      this.displayActions = false;
    }
    this.router.navigate([link]);
    this.displayActions = false;
  }

}
